module.exports = __webpack_public_path__ + "static/media/Kokperspektiv3.72d46fec.jpg";